
import { apiRequest } from '../../apiCall'


export const loginUser= (params) => apiRequest('Token.Token',params)
export const getCareerField= () => apiRequest('CareerField.CareerField',{},'',true)
export const registerUser= (params) => apiRequest('Register.RegisterUser',params,'',true)
export const checkExistEmail= (params) => apiRequest('Auth.CheckEmail',params)
export const captchaVerified= (params) => apiRequest('Captcha.Captcha',params)
export const sendResetPasswordEmail= (params) => apiRequest('UserManagement.SendResetPasswordEmail',params)